"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var responsive_1 = require("@dynamynd/responsive");

var styled_components_1 = __importDefault(require("styled-components"));

var ColumnFlexStartResponsiveRightDecorated = styled_components_1.default(components_lib_1.ColumnFlexStartResponsive)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: ", "%;}\n    margin-top: ", "px;\n"], ["\n    max-width: ", "%;}\n    margin-top: ", "px;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmallOrMedium(activeBreakpoint) ? 100 : 80;
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? 30 : 0;
});
exports.default = responsive_1.withResponsiveMeta(ColumnFlexStartResponsiveRightDecorated);
var templateObject_1;